/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { MainPageTag } from './MainPageTag'
import { MainPageTagFromJSON, MainPageTagFromJSONTyped, MainPageTagToJSON } from './MainPageTag'

/**
 *
 * @export
 * @interface PaginatedMainPageTagListAdmin
 */
export interface PaginatedMainPageTagListAdmin {
  /**
   *
   * @type {Array<MainPageTag>}
   * @memberof PaginatedMainPageTagListAdmin
   */
  results: Array<MainPageTag>
  /**
   *
   * @type {number}
   * @memberof PaginatedMainPageTagListAdmin
   */
  count: number
  /**
   *
   * @type {string}
   * @memberof PaginatedMainPageTagListAdmin
   */
  next: string | null
  /**
   *
   * @type {string}
   * @memberof PaginatedMainPageTagListAdmin
   */
  previous: string | null
}

/**
 * Check if a given object implements the PaginatedMainPageTagListAdmin interface.
 */
export function instanceOfPaginatedMainPageTagListAdmin(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'results' in value
  isInstance = isInstance && 'count' in value
  isInstance = isInstance && 'next' in value
  isInstance = isInstance && 'previous' in value

  return isInstance
}

export function PaginatedMainPageTagListAdminFromJSON(json: any): PaginatedMainPageTagListAdmin {
  return PaginatedMainPageTagListAdminFromJSONTyped(json, false)
}

export function PaginatedMainPageTagListAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedMainPageTagListAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    results: (json['results'] as Array<any>).map(MainPageTagFromJSON),
    count: json['count'],
    next: json['next'],
    previous: json['previous'],
  }
}

export function PaginatedMainPageTagListAdminToJSON(
  value?: PaginatedMainPageTagListAdmin | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    results: (value.results as Array<any>).map(MainPageTagToJSON),
    count: value.count,
    next: value.next,
    previous: value.previous,
  }
}
